const TO_MATCH_APPLE = [/iPhone/i, /iPad/i, /iPod/i];
const TO_MATCH_ANDROID = [/Android/i];
const TO_MATCH_OTHER = [/webOS/i, /BlackBerry/i, /Windows Phone/i];
const TO_MATCH_IOS_SHOP_APP = [/Mobile Shop App/i];
const TO_MATCH_ANDROID_SHOP_APP = [/; wv\)/i];

const matchesUserAgent = (patterns: Array<RegExp>) => {
    if (typeof window === 'undefined') {
        return false;
    }

    return patterns.some((pattern) => navigator.userAgent.match(pattern));
};

export const isIOS = () => matchesUserAgent(TO_MATCH_APPLE);

export const isAndroid = () => matchesUserAgent(TO_MATCH_ANDROID);

const isOtherMobileDevice = () => matchesUserAgent(TO_MATCH_OTHER);

const isInShopApp = () => {
    return matchesUserAgent(TO_MATCH_IOS_SHOP_APP) || matchesUserAgent(TO_MATCH_ANDROID_SHOP_APP);
};

export const isShopApp = () => {
    return isIOS() || isAndroid() || isOtherMobileDevice();
};

export const isIOSBrowser = () => {
    return isIOS() && !isInShopApp();
};

export const isAndroidBrowser = () => {
    return isAndroid() && !isInShopApp();
};
